module.exports = __webpack_public_path__ + "img/icon-warning-wind-yellow.0d82c850.svg";